import React from 'react'
import { SearchMessageDisplayStyled } from './InitialDisplay.styles'
import { Icon } from '@mobi/component-library/Common/Icon'
import { SearchTextLabel } from '../SearchTextLabel/SearchTextLabel'
import { SearchTextLabelFontSize } from '../SearchTextLabel/SearchTextLabelStyled.styles'
import { hexColors } from '@mobi/settings/hexColors'

export const SearchErrored = () => {
  return (
    <SearchMessageDisplayStyled>
      <Icon type='warningCircled' size='6rem' color={hexColors.darkGrey} />
      <SearchTextLabel size={SearchTextLabelFontSize.Large}>An Error has Occurred</SearchTextLabel>
      <SearchTextLabel size={SearchTextLabelFontSize.Small}>Please try again.</SearchTextLabel>
    </SearchMessageDisplayStyled>
  )
}
